<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { hexToNormalizedRGBA } from "../../../shared/common";
  import { getSelectedShapes } from "../../../shared/globalState/a";

  let dispatch = createEventDispatcher();

  // Props
  export let value = "#3F47CC";
  export let width = "110px";
  export let height = "28px";
  export let showLabel = true;
  export let label = "Цвет";

  // Internal state
  let selectedLineColor = value;
  let colorInput;

  // Reactive statement to update internal state when value prop changes
  $: selectedLineColor = value;

  function changeLineColor(event) {
    selectedLineColor = event.target.value;
    
    // Update selected shapes with new color
    getSelectedShapes().forEach((shape) => {
      if ("color" in shape) {
        shape.color = hexToNormalizedRGBA(selectedLineColor);
      }
    });
    
    // Dispatch change event
    dispatch("change", { color: selectedLineColor });
  }


  function handleColorPickerInputClick(event) {
    var colorPalette = document.querySelector(".jscolor-picker");

    if (colorPalette) {
      colorPalette.addEventListener("mouseenter", function (e) {
        // Dispatch event to parent to set mode to "none"
        dispatch("colorPickerMouseEnter");
      });
    }
  }

  // Initialize jscolor when component mounts
  onMount(() => {
    // Use a small delay to ensure the DOM is ready
    setTimeout(() => {
      // Access jscolor as global variable (it's already initialized in App.svelte)
      if (typeof window !== 'undefined' && window.jscolor) {
        // Install jscolor on the entire document to catch our input
        if (window.jscolor.install) {
          window.jscolor.install();
        }
      }
    }, 100);
  });
</script>

<div class="color-picker-container">
  <!-- Modern color picker button -->
  <button
    class="color-picker-button"
    style="width: {width}; height: {height};"
    type="button"
    title="Select color"
  >
    <div class="color-preview" style="background-color: {selectedLineColor};"></div>
    {#if showLabel}
      <span class="color-label">{label}</span>
    {/if}
    <div class="color-dropdown-icon">▼</div>
    
    <!-- Overlay input for jscolor -->
    <input 
      bind:this={colorInput}
      class="overlay-input"
      id="color-picker" 
      bind:value={selectedLineColor} 
      on:change={changeLineColor} 
      on:click={handleColorPickerInputClick} 
      data-jscolor 
    />
  </button>
</div>

<style>
  .color-picker-container {
    display: inline-flex;
    position: relative;
    margin-right: 8px;
    margin-left: 4px;
    align-items: center;
    vertical-align: middle;
  }

  .color-picker-button {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background: #f8fafc;
    cursor: pointer;
    position: relative;
    font-size: 14px;
    font-weight: 500;
  }

  .color-picker-button:hover {
    background: #e2e8f0;
    border-color: #94a3b8;
  }

  .color-picker-button:active {
    background: #cbd5e1;
  }

  .color-preview {
    width: 16px;
    height: 16px;
    border-radius: 3px;
    border: 1px solid #d1d5db;
    flex-shrink: 0;
  }

  .color-label {
    font-size: 14px;
    font-weight: 500;
    color: #475569;
    flex-grow: 1;
    text-align: left;
  }

  .color-dropdown-icon {
    font-size: 10px;
    color: #64748b;
    flex-shrink: 0;
  }

  /* Focus styles */
  .color-picker-button:focus {
    outline: none;
    border-color: #94a3b8;
    box-shadow: 0 0 0 2px rgba(148, 163, 184, 0.2);
  }

  /* Disabled state */
  .color-picker-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .color-picker-button:disabled:hover {
    background: #f8fafc;
    border-color: #d1d5db;
  }

  .overlay-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    border: none;
    background: transparent;
  }
</style>